/* CQ product card: the touch "+" toggle that opens the in-tile panel (whole-house pattern). */
(() => {
  if (window.cqCardInit) return;
  window.cqCardInit = true;
  const close = (card) => {
    card.classList.remove('is-open');
    const b = card.querySelector('.cq-card-plus');
    if (b) b.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('.cq-card-plus');
    if (plus) {
      const card = plus.closest('.cq-card');
      const open = !card.classList.contains('is-open');
      document.querySelectorAll('.cq-card.is-open').forEach((c) => { if (c !== card) close(c); });
      card.classList.toggle('is-open', open);
      plus.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!e.target.closest('.cq-card.is-open')) document.querySelectorAll('.cq-card.is-open').forEach(close);
  });
  /* AJ r5 item 1: keyboard focus opens a card's actions only while the shopper is moving focus by keyboard.
     After a pointer click (Compare, Add to cart, Configure) focus can stay inside the card, and a later
     scroll key (Page Down, arrows, End) makes that focus "visible" and reopened the actions with no pointer
     on the card. A pointer press marks the page; Tab and widget navigation clear it (component-card.css reads it). */
  const root = document.documentElement;
  const pointerNav = () => {
    if (!root.classList.contains('cq-pointer-nav')) root.classList.add('cq-pointer-nav');
  };
  document.addEventListener('pointerdown', pointerNav, { capture: true, passive: true });
  document.addEventListener('touchstart', pointerNav, { capture: true, passive: true });
  document.addEventListener('keydown', (e) => {
    const widgetNavigation = /^(Arrow(?:Up|Down|Left|Right)|Home|End)$/.test(e.key)
      && e.target instanceof Element
      && e.target.matches('input[type="radio"], input[type="range"], select, [role="radio"], [role="tab"], [role="option"], [role="menuitem"], [role="combobox"], [role="listbox"], [role="listbox"] *');
    if (e.key === 'Tab' || widgetNavigation) root.classList.remove('cq-pointer-nav');
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    /* Lane H2: Escape inside a popup (Configure) closes the popup only; the card's panel stays open so focus can return to its opener. */
    if (e.target instanceof Element && e.target.closest('dialog[open]')) return;
    const card = document.querySelector('.cq-card.is-open');
    if (!card) return;
    close(card);
    card.querySelector('.cq-card-plus')?.focus({ preventScroll: true });
  });
})();

/* Dialog lifecycle analytics, including dialogs added after page load. */
(() => {
  const p = window.HTMLDialogElement?.prototype;
  if (!p?.showModal || p.showModal.cqTracked) return;
  const show = p.showModal;
  const tracked = new WeakSet();
  const emit = (state, d) => {
    try {
      window.posthog?.capture?.('cq_dialog_' + state, {
        dialog: d.dataset.cqDialog || d.classList[0] || d.id || 'dialog'
      });
    } catch (_) { /* Analytics must never interrupt a dialog. */ }
  };
  p.showModal = function (...args) {
    const open = this.open;
    const result = show.apply(this, args);
    if (!tracked.has(this)) {
      this.addEventListener('close', () => emit('close', this));
      tracked.add(this);
    }
    if (!open && this.open) emit('open', this);
    return result;
  };
  p.showModal.cqTracked = true;
})();
